import HOEditCoverages from 'edge/policycommon/ho/directives/HOEditCoverages';
import HOViewCoverages from 'edge/policycommon/ho/directives/HOViewCoverages';
import hoCoveragesExpressionValidation from './config/ScheduledPropertiesExpressionValidation';
import 'edge/policycommon/common/app';
import 'gw-portals-exp-lang-angular';

export default angular.module('edge.policycommon.ho.app', ['edge.policycommon.common.app', 'edge.platform.el']).directive('gwPcHoEditCoverages', HOEditCoverages).directive('gwPcHoViewCoverages', HOViewCoverages).run(['ExpressionLanguageService', function (ExpressionLanguage) {
    ExpressionLanguage.getCompilationContext('pc').registerType('edge.capabilities.policyjob.lob.homeowners.coverages.PropertyDescriptorsUtil', hoCoveragesExpressionValidation);
}]);


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/conditional?if=policycommon_lob&equals=ho!./common/js/src/edge/policycommon/ho/app.js
// module id = 467
// module chunks = 0